var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.25C5.50391 9.25 3.5 7.24609 3.5 4.75C3.5 2.28906 5.50391 0.25 8 0.25C10.4609 0.25 12.5 2.28906 12.5 4.75C12.5 7.24609 10.4609 9.25 8 9.25ZM8 1.375C6.13672 1.375 4.625 2.92188 4.625 4.75C4.625 6.61328 6.13672 8.125 8 8.125C9.82812 8.125 11.375 6.61328 11.375 4.75C11.375 2.92188 9.82812 1.375 8 1.375ZM9.75781 10.9375C13.1328 10.9375 15.875 13.6797 15.875 17.0547C15.875 17.7227 15.3125 18.25 14.6445 18.25H1.32031C0.652344 18.25 0.125 17.7227 0.125 17.0547C0.125 13.6797 2.83203 10.9375 6.20703 10.9375H9.75781ZM14.6445 17.125C14.6797 17.125 14.75 17.0898 14.75 17.0547C14.75 14.3125 12.5 12.0625 9.75781 12.0625H6.20703C3.46484 12.0625 1.25 14.3125 1.25 17.0547C1.25 17.0898 1.28516 17.125 1.32031 17.125H14.6445Z",
    fill: "#7D8597"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.68e00942e1d86716fdf24d3d0ba3973f.svg";
export { ForwardRef as ReactComponent };